/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  Autocomplete selectors
 */

import type { State } from '@zcode/state-type'
import { compose } from 'redux'

const selectAutocomplete = (state: State) => state.autocomplete

export const selectShowMobileAutocomplete = compose(
  (state) => state.showMobileAutocomplete,
  selectAutocomplete
)

export const selectIsCurrentLocationLoading = compose(
  (state) => state.isCurrentLocationLoading,
  selectAutocomplete
)

export const selectFetchingKey = compose((state) => state.fetchingKey, selectAutocomplete)

export const selectMobileOrigin = compose((state) => state.mobileOrigin, selectAutocomplete)
export const selectIsFetching = compose((state) => state.isFetching, selectAutocomplete)
